import React from 'react';
import {
  GET_USER_TODOS,
  UPDATE_TODO,
} from 'graphql/todos';
import { useMutation, Subscription } from 'react-apollo';
import Spin from 'components/common/Spin';
import TodoCard from './TodoCard';
import useSnack from 'hooks/useSnack';

const TodoTasks = ({ user }) => {
  const [updateTodo] = useMutation(UPDATE_TODO);
  const snack = useSnack();

  const markDone = async (task) => {
    await updateTodo({ variables: { id: task.id, data: { status: 'done'}  } }).then(
      () => {
        snack.success('Marked as Done.');
      },
      (e) => snack.error(e.message),
    );
  };

  return (
    <>
      <Subscription
        subscription={GET_USER_TODOS}
        variables={{ userId: user.id, status: ['pending', 'doing'] }}
      >
        {({ data, loading, error}) => {
          if (loading) return <Spin spinning />;
          if (error) return error.message;

          const { todos } = data;

          return todos.map(i => (
            <TodoCard
              markDone={markDone}
              user={user}
              data={i}
              key={i.id}
            />
          ))

        }}
      </Subscription>
    </>
  )
};

export default TodoTasks;